import { Phone, MapPin, Clock, Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useState } from "react";

import logo from "@/assets/logo.webp";
const navLinks = [{
  label: "Home",
  href: "#"
}, {
  label: "Services",
  href: "#services"
}, {
  label: "Why Us",
  href: "#why-us"
}, {
  label: "Testimonials",
  href: "#testimonials"
}, {
  label: "FAQ",
  href: "#faq"
}, {
  label: "Contact",
  href: "#contact"
}];
export const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  return <header className="fixed top-0 left-0 right-0 z-50 bg-card/95 backdrop-blur-md border-b border-border">
      {/* Top bar */}
      <div className="hidden md:block text-primary-foreground py-2 bg-sidebar-ring">
        <div className="container mx-auto px-4 flex items-center justify-between text-sm">
          <div className="flex items-center gap-6">
            <a href="tel:+916353963147" className="flex items-center gap-2 hover:opacity-80 transition-opacity">
              <Phone className="w-4 h-4" />
              <span>063539 63147</span>
            </a>
            <span className="flex items-center gap-2">
              <Clock className="w-4 h-4" />
              <span>Mon - Sat: 10AM - 8PM</span>
            </span>
          </div>
          <div className="flex items-center gap-2">
            <MapPin className="w-4 h-4" />
            <span>Kudasan, Gandhinagar</span>
          </div>
        </div>
      </div>

      {/* Main nav */}
      <nav className="container mx-0 px-[5px] py-[2px] bg-sky-50">
        <div className="flex items-center justify-between">
          <a href="#" className="flex items-center">
            <img src={logo} alt="Smile Care Dental - Best Dental Clinic in Gandhinagar" width={80} height={80} className="h-20 md:h-20 w-15 object-contain rounded-full" />
          </a>

          {/* Desktop nav */}
          <div className="hidden lg:flex items-center gap-8">
            {navLinks.map(link => <a key={link.label} href={link.href} className="text-muted-foreground hover:text-primary transition-colors font-medium">
                {link.label}
              </a>)}
          </div>

          <div className="hidden lg:flex items-center gap-3">
            <Button variant="whatsapp" asChild>
              <a href="https://wa.me/916353963147?text=Hi%2C%20I%20would%20like%20to%20book%20an%20appointment" target="_blank" rel="noopener noreferrer">
                Book on WhatsApp
              </a>
            </Button>
          </div>

          {/* Mobile menu button */}
          <button onClick={() => setIsOpen(!isOpen)} className="lg:hidden p-2 text-foreground" aria-label="Toggle menu">
            {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile menu */}
        <div 
          className={`lg:hidden overflow-hidden transition-all duration-300 ease-out ${
            isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
          }`}
        >
          <div className="py-4 space-y-4">
            {navLinks.map(link => (
              <a 
                key={link.label} 
                href={link.href} 
                onClick={() => setIsOpen(false)} 
                className="block text-muted-foreground hover:text-primary transition-colors font-medium py-2"
              >
                {link.label}
              </a>
            ))}
            <Button variant="whatsapp" className="w-full" asChild>
              <a href="https://wa.me/916353963147?text=Hi%2C%20I%20would%20like%20to%20book%20an%20appointment" target="_blank" rel="noopener noreferrer">
                Book on WhatsApp
              </a>
            </Button>
          </div>
        </div>
      </nav>
    </header>;
};